/* global $ */

const $modules = $.$body.find('[data-module],.module');

// add class to last module
$modules.last().addClass('last-module');

let timeOutId = null;

// Accordions
$.$body
  .on(
    'focus',
    '.module__accordion .js-accordion-button, .module__person-items .js-accordion-button',
    (e) => {
      $(e.currentTarget).attr('aria-selected', true);
    },
  )
  .on(
    'blur',
    '.module__accordion .js-accordion-button, .module__person-items .js-accordion-button',
    (e) => {
      $(e.currentTarget).attr('aria-selected', false);
    },
  )
  .on(
    'click',
    '.module__accordion .js-accordion-button, .module__person-items .js-accordion-button',
    (e) => {
      e.preventDefault();

      // console.log('accordion open');

      const $button = $(e.currentTarget);
      const isExpanded = $button.attr('aria-expanded') === 'true';
      const $section = $button.parent().find('.accordion__expand-section');

      $button.attr('aria-expanded', !isExpanded);
      $section.attr('aria-hidden', isExpanded);

      if (!isExpanded) {
        // const $rowAnchor = $header.closest('.accordion__single-row');
        // window.scrollTo(0, $rowAnchor.offset().top - 95);
        $button
          .parent()
          .find('.button-collapse')
          .attr('aria-expanded', 'true');
        clearTimeout(timeOutId);
        timeOutId = setTimeout(() => {
          $section.addClass('js-accordion-fully-open');
        }, 500); // makes sure if the content is really long, it's eventually all opened up
        // if (false && 'scrollIntoViewIfNeeded' in $rowAnchor.get(0)) {
        //   $rowAnchor.get(0).scrollIntoViewIfNeeded(false);
        // } else if (false && 'scrollIntoView' in $rowAnchor.get(0)) {
        //   $rowAnchor.get(0).scrollIntoView(true);
        // } else {
        //   window.scrollTo(0, $rowAnchor.offset().top - 95);
        // }
      } else {
        $section.removeClass('js-accordion-fully-open');
        $button
          .parent()
          .find('.button-expand')
          .attr('aria-expanded', 'false');
        clearTimeout(timeOutId);
      }
    },
  );
